/**
 * Add a new question
 *
 * @param vars
 * @returns {boolean}
 */
function add_evaluation_question(vars) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/questions/add/',
        onOpen: function(elm, popup) {
            init_question_selectors(elm);

            elm.find('form').ajaxFormSubmit((data) => {
                $('body').doneLoading();

                squde_reload_for_flashes();

                if (vars && vars.callback) {
                    vars.callback(data);
                }
                if (!(vars && Object.keys(vars).includes('reload') && vars.reload === false)) {
                    reload_location_if_needed(true);
                } else {
                    popup.close();
                }
                if (!document.closeWindow) open_new_object(view_evaluation_question, data);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * View the given question
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_evaluation_question(id) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/questions/view/'+id,
        onOpen: function(elm, popup) {
            init_question_selectors(elm);

            elm.find('form').ajaxFormSubmit((data) => {
                updateObject('evaluation-question', id);
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(document.closeWindow);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Delete the given question
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function delete_evaluation_question(id, name) {
    name = decodeURI(name);
    custom_delete_with_confirmation('/evaluations/questions/delete/' + id,id,"Weet u zeker dat u \""+name+"\" wilt verwijderen? (U kunt hiermee evaluatie-historie corrumperen)",'evaluation-question', () => {
        squde_reload_for_flashes();
        reload_location_if_needed(false);
    });
    return false;
}

function init_question_selectors(elm) {
    const $ = jQuery.noConflict();

    elm.find('[data-evaluation-question-option-group-selector], [data-evaluation-category-selector]').each(function() {
        const prev = $(this).prev();
        if (prev.length > 0) {
            $(this).attr('data-current-value', prev.attr('data-current-value'));
            prev.remove();
            $(this)
                .removeAttr('style')
                .removeAttr('data-uid')
                .removeClass('has-special-selector');
        }

        if ($(this).is('[data-evaluation-question-option-group-selector]')) {
            $(this).evaluationQuestionOptionGroupSelector();
        } else if ($(this).is('[data-evaluation-category-selector]')) {
            $(this).change(function() {
                $(this).parents('.sortable-item:first').children('.view-wrapper').find('span').removeAttr('class').html($(this).children('[value="' + $(this).val() + '"]').html());
            }).evaluationCategorySelector();
        }
    });

    elm.find('.type-select').unbind('change').change(function() {
        const v = $(this).val();
        $(this).parents('.row:first').find('label.option-group-label').toggle(v === 'options' || v === 'sum');

        $(this).parents('.row:first').parent().find('.required-container').toggle(v !== 'options' && v !== 'rate');
    }).trigger('change');
}
